import { render, staticRenderFns } from "./StockNote.vue?vue&type=template&id=447a041a&scoped=true&"
import script from "./StockNote.vue?vue&type=script&lang=js&"
export * from "./StockNote.vue?vue&type=script&lang=js&"
import style0 from "./StockNote.vue?vue&type=style&index=0&id=447a041a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447a041a",
  null
  
)

export default component.exports